<template lang="pug">
v-container#package-tables(fluid, tag="div")
  h3 Package Avaiable for purchase
  v-item-group(active-class="primary")
    v-container
      v-row(v-if="package_list.length")
        v-col(
          v-for="item in package_list"
          :key="item.package_id"
          cols="12"
          md="4"
        )
          v-item(v-slot="{ active, toggle }")
            v-card(
              class="d-flex align-center"
              light
              height="400"
              @click="purchase(item)"
            )
              v-scroll-y-transition
                div(
                  class="display-3 flex-grow-1 text-center p-4"
                )
                  h3.text-info.mb-4 {{ item.package_name }}
                  h4.text-success - Validity -
                  h5 {{ item.valid_period }} Days
                  h4.text-success - Price -
                  h5 RM {{ item.pricing }}
                  h4.text-success - Available Balance -
                  h5 RM {{ item.available_balance }}
                  h6.form-control.mt-4 {{ item.description }}
                  h6.text-danger Click to purchase
      v-row(
        v-else
      )
        h3.text-info No packages avaiable for purchase.
  v-dialog(data-app, v-model="dialog", persistent, max-width="600px")
    v-card
      v-card-title
        span.headline Purchase Package
      v-card-text
        v-form.p-4(ref="edit", v-model="valid", lazy-validation)
          v-text-field.mb-2(
            readonly,
            v-model="editedItem.id",
            label="Package ID",
            required
          )
          v-text-field.mb-2(
            readonly,
            v-model="editedItem.package_name",
            label="Package Name",
            required
          )
          v-text-field.mb-2(
            readonly,
            v-model="editedItem.pricing",
            label="Price",
            required
          )
          v-text-field.mb-2(
            readonly,
            v-model="editedItem.available_balance",
            label="Available balance",
            required
          )
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="close") Cancel
        v-btn(color="blue darken-1", text, @click="save") Purchase
</template>

<script>
export default {
  name: "Package",
  data() {
    return {
      expanded: [],
      search: "",
      editedIndex: -1,
      dialog: false,
      editedItem: {},
      package_list: [],
      valid: true,
      loading: false,
    };
  },
  mounted() {
    this.getPackageList();
  },
  methods: {
    purchase(item) {
      this.editedIndex = this.package_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    save() {
      if (!this.$refs.edit.validate()) return;

      const url = "https://saas-api.xendity.com/v1/user/purchase-package";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        package_id: this.editedItem.id
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Purchase package error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Purchase package successful!", "Success", "success");
                this.close();
                this.getPackageList();
              }
            }
          } catch (error) {
            this.$swal(
              "Purchase package error",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Purchase package error",
            response.body.data.message,
            "error"
          );
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    getPackageList() {
      const url = "https://saas-api.xendity.com/v1/user/available-package";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then((response) => {
          // Success
          try {
            if (response) {
              if (response.body.success == false)
                this.$swal(
                  "Get purchae package list failed",
                  response.body.data.message,
                  "error"
                );
              else this.package_list = response.body.data.package_list;
            }
          } catch (error) {
            this.$swal(
              "Get purchase package list failed",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Get purchase package list failed",
            response.body.data.message,
            "error"
          );
        });
    },
  },
};
</script>